import { render, staticRenderFns } from "./MultipleChoiceTableDialog.vue?vue&type=template&id=c9256428&"
import script from "./MultipleChoiceTableDialog.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceTableDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceTableDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9256428')) {
      api.createRecord('c9256428', component.options)
    } else {
      api.reload('c9256428', component.options)
    }
    module.hot.accept("./MultipleChoiceTableDialog.vue?vue&type=template&id=c9256428&", function () {
      api.rerender('c9256428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableDialog/MultipleChoiceTableDialog.vue"
export default component.exports